
const config = require('./js/cfg/');

require('debug-globals').extend({ config });

module.exports = config;
